import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import quoteSvg from '../../resources/quote.svg'
import postShapeSvg from 'resources/svg/plp-shape-right.svg'

export const Container = styled.div`
  padding: 0 0 40px;
  overflow-x: hidden;

  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  .post-content,
  .post-extra,
  .post-related {
    ${props => props.theme.css.container};
    box-sizing: border-box;
  }

  .post-intro {
    text-align: center;

    h1 {
      ${props => props.theme.css.container};
      margin: 40px auto 20px;
      font: ${font('alt', 'normal', '30px/1.5')};
      text-align: center;
      ${bp('sm')`
        font-size: 26px;
        margin: 10px auto;
      `}
    }

    > p {
      ${props => props.theme.css.container};
      ${bp('sm')`
        padding: 0;
        margin: 0;
      `}
    }

    img {
      object-fit: cover;
    }
  }

  .post-content {
    line-height: 1.6;
    position: relative;
    margin: 40px auto;
    display: flex;
    flex-wrap: wrap;

    > div {
      &:first-child {
        width: 23%;
        margin-right: 2%;
        ${bp('sm')`
        width: 100%;
      `}
      }

      &:last-child {
        width: 75%;
        ${bp('sm')`
        width: 100%;
      `}
      }
    }

    &::after {
      content: '';
      width: 500px;
      height: 500px;
      position: absolute;
      z-index: -1;
      right: -20%;
      bottom: 0;
      background: url(${postShapeSvg}) no-repeat;
      background-size: contain;
      ${bp('lg')`
        right: -35%;
      `}
      ${bp('sm')`
        content: unset;
      `}
    }

    h2 {
      font: ${font('default', 'normal', '28px/1.6')};
      color: ${props => props.theme.palette.general.strong};
      margin: 40px 0 10px;
      ${bp('sm')`
        font-size: 22px;
      `}
    }

    a {
      color: ${props => props.theme.palette.primary.beta};
    }

    p {
      font: ${font('default', 'normal', '16px/1.6')};
      margin: 0 0 25px;
    }

    img,
    iframe {
      & + .caption {
        font-size: 11px;
        color: ${props => props.theme.palette.general.dark};
      }
    }

    img {
      object-fit: cover;

      &.full-w {
        width: 100%;
      }
    }

    .columns {
      display: flex;
      margin: 20px auto;
      ${bp('sm')`
        flex-wrap: wrap;
      `}

      &--2 {
        > div {
          width: 100%;
          ${bp('sm')`
            margin-bottom: 20px;
          `}

          &:first-child {
            margin-right: 2%;
            ${bp('sm')`
              margin-right: 0;
            `}
          }
        }
      }
    }

    .full-video {
      position: relative;
      display: block;
      width: 100%;
      padding: 0;
      overflow: hidden;
      margin: 25px 0;

      &::before {
        content: '';
        display: block;
        padding-top: 56.25%;
      }

      iframe {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
      }
    }

    .featured-quote {
      display: flex;
      justify-content: center;
      padding: 30px;
      margin: 20px 0;
      ${bp('sm')`
        padding: 0;
      `}

      p {
        max-width: 500px;
        margin: 0;
        font: ${font('default', 'light', '20px/1.3')};
        color: ${props => props.theme.palette.primary.alphaDark};
        text-align: center;
        ${bp('sm')`
          font-weight: ${(props: any) => props.theme.font.default.bold};
        `}
      }

      &::before,
      &::after {
        content: '';
        width: 50px;
        height: 50px;
        display: inline-block;
        background: url(${quoteSvg}) no-repeat center;
        background-size: contain;
        ${bp('sm')`
          content: unset;
        `}
      }

      &::after {
        transform: rotate(180deg);
      }

      &-image {
        display: flex;
        margin: 40px 0;

        > img {
          width: 60%;
          margin: 0 0 4%;
        }

        > p {
          width: 40%;
          padding: 40px;
          display: flex;
          align-items: center;
          margin-top: 7%;
          margin-left: -10%;
          margin-bottom: 0;
          background: ${props => props.theme.palette.primary.beta};
          color: ${props => props.theme.palette.general.light};
          font: ${font('default', 'light', '26px/1.3')};
          text-align: center;
          position: relative;
          ${bp('sm')`
            font: ${font('default', 'light', '20px/1.5')};
          `}

          &::before {
            content: '';
            width: 80px;
            height: 80px;
            display: inline-block;
            background: url(${quoteSvg}) no-repeat center;
            position: absolute;
            top: -20px;
            left: -45px;
            background-size: contain;
            filter: brightness(0) invert(1);
            ${bp('sm')`
              width: 40px;
              height: 40px;
              top: 2px;
              left: 5px;
            `}
          }
        }

        ${bp('sm')`
          flex-wrap: wrap;

          > img,
          > p {
            width: 100%;
            margin: 0;
          }
        `}
      }
    }

    cite,
    blockquote {
      display: block;
      margin: 40px 0;

      p {
        color: ${props => props.theme.palette.primary.alpha};
        font: ${font('default', 'light', '32px/1.6')};
        font-style: italic;
        margin: 10px 0;
        ${bp('sm')`
          font-size: 20px;
        `}

        small {
          color: ${props => props.theme.palette.general.greyDark};
          font: ${font('default', 'normal', '14px/1.6')};
        }
      }
    }
  }

  .image-wrapper {
    ${bp('sm')`
        width: 90%!important;
        margin: auto;
    `}
  }

  .post-extra {
    display: flex;
    justify-content: space-around;
    padding: 20px 0;
    border: 1px solid ${props => props.theme.palette.general.greyLight};
    border-width: 1px 0;
    font: ${font('default', 'medium', '14px/1')};
    ${bp('sm')`
      flex-direction: column;
      align-items: center;
      font: ${font('default', 'medium', '16px/1')};

      > div {
        margin: 10px auto;
      }
    `}
  }

  .related-title {
    ${props => props.theme.css.container};
    text-align: center;
    font: ${font('default', 'medium', '20px/1.2')};
    border-bottom: 1px solid ${props => props.theme.palette.general.grey};
    padding-bottom: 15px;
    margin: 15px auto;
  }

  .post-related {
    > div {
      border-bottom: 1px solid ${props => props.theme.palette.general.grey};
      margin-bottom: 15px;
      padding-bottom: 15px;

      .item {
        .content {
          justify-content: center;
          margin: 0;
        }

        .image {
          ${bp('sm')`
            min-width: 100px;
            height: auto;
          `}
        }
      }
    }
  }
`
